module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"同意する":"同意する"},"en":{"同意する":"Accept"}}')
  delete Component.options._Ctor
}
